<template>
  <div class="echarts-warp">
    <div class="echart-content">
      <div
        :id="getId"
        style="padding-top: 20px; height: 100%; box-sizing: border-box"
        v-resize="resize"
      ></div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: "图表标题",
    },
    timeTitle: {
      type: String,
      default: "",
    },
    unit: {
      type: String,
      default: "kWh",
    },
    /**
     * 是否显示图表标题
     */
    showTitle: {
      type: Boolean,
      default: true,
    },
    /**
     * 是否显示图表标题
     */
    showMax: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    data() {
      let vm = this;
      if (vm.data.length == 0 || vm.data.length == 1) {
        vm.drawLine();
      } else {
        vm.drawLines();
      }
    },
  },
  data() {
    return {
      id: "",
      myChart: null,
      isShow: false,
      height: 400,
    };
  },
  computed: {
    getId() {
      let vm = this;
      vm.id =
        "chart" +
        (Math.random() * 10000000).toString(16).substr(0, 4) +
        "-" +
        new Date().getTime() +
        "-" +
        Math.random().toString().substr(2, 5);
      return vm.id;
    },
  },
  mounted() {
    let vm = this;
    window.addEventListener("resize", () => {
      if (vm.myChart) {
        vm.myChart.resize();
      }
    });
    if (vm.data.length == 0 || vm.data.length == 1) {
      vm.drawLine();
    }
  },
  methods: {
    resize(){
      let vm = this;
      if (vm.myChart) {
        vm.myChart.resize();
      }
    },
    drawLine() {
      let vm = this;
      let obj = vm.data[0];
      let series = [],
        xAxis = {},
        yAxis = [];
      // 判断是不是不规则的时间
      xAxis = {
        data: obj.xData,
        //  type: "time"
      };
      let markPoint = null
      if(vm.showMax){
        markPoint ={
            data: [{ type: "max", name: "最大值" }],
          }
      }else{
        markPoint ={}
      }

      series = [
        {
          name: obj.tip[0],
          type: "line",
          data: obj.data[0],
          markPoint:markPoint ,
        },
        {
          name: obj.tip[1],
          type: "line",
          data: obj.data[1],
          markPoint: markPoint,
        },
      ];
      if (!obj.ifBgColor) {
        series[0].areaStyle = {
          color: "#D7D2E5",
          opacity: "0.3",
        };
        series[1].areaStyle = {
          color: "#DB8F86",
          opacity: "0.3",
        };
      }
      if (vm.myChart == null) {
        vm.myChart = vm.$echarts.init(document.getElementById(vm.id));
      } else {
        vm.myChart.clear();
      }
      console.log(obj);
      // 绘制图表
      vm.myChart.setOption({
        title: {
          text: obj.title.replace(/[\r\n]/g, ""),
          subtext: "查询时间：" + vm.timeTitle.replace(/[\r\n]/g, ""),
          left: "center",
        },
        tooltip: {
          trigger: "axis",
        },
        toolbox: {
          show: true,
          right: 20,
          feature: {
            saveAsImage: {},
            magicType: {
              type: ["line", "bar"],
            }, //切换为折线图，切换为柱状图
          },
        },
        // color: ["#D7D2E5", "#DB8F86"],
        color: ['#CCCC00', '#0080FF'],
        grid: {
          left: "5%",
          right: "5%",
          top: "15%",
          bottom: "10%",
        },
        legend: {
          data: obj.tip,
          selected: obj.selected,
          left: "center",
          top: "9%",
          icon: "rect", // 这个字段控制形状  类型包括 circle，rect ，roundRect，triangle，diamond，pin，arrow，none
          itemWidth: 12, // 设置宽度
          itemHeight: 2, // 设置高度
        },
        dataZoom: [
          {
            type: "inside",
            show: true,
            realtime: true,
          },
          {
            show: true,
            realtime: true,
            end: 100,
            type: "slider",
            width: "92%",
            left: "center",
          },
        ],
        xAxis: xAxis,
        yAxis: [
          {
            name: vm.unit,
            type: "value",
            scale: true,
          },
        ],
        series: series,
      });
      vm.isShow = true;
    },
    clickoTherAdd() {
      this.$emit("clickoTherAdd");
    },
  },
};
</script>
<style lang="scss" scoped>
.echarts-warp {
  width: 100%;
  padding: 14px;
  box-sizing: border-box;
  border-radius: 5px;
  background: #fff;
  border: 1px solid #dedcdc;
  height: 100%;
}
.echart-content {
  border-radius: 5px;
  border: 1px solid #dedcdc;
  overflow: hidden;
  position: relative;
  height: 100%;
}
.echarts-title {
  height: 34px;
  line-height: 34px;
  padding-left: 14px;
  color: #fff;
  background: #1d6ce9;
}
.iconlocal {
  position: absolute;
  top: 40px;
  right: 110px;
  z-index: 999;
  i {
    cursor: pointer;
  }
}
.iconlocal:hover {
  cursor: pointer;
  color: #1d6ce9;
}
.chartbox {
  position: absolute;
  top: 35px;
}
</style>
